<div id="sideNavBoxAngular" role="navigation" [class.collapseMenu]="isMenuCollapse"
  class="sk-sidebar-mnu-body">
  <div class="sk-side-body-inn">
    <div class="sk-sidebar-logo">
      <div class="sk-sidebar-logo-icon">
        <div class="sk-logo-chevron-stack">
          <img class="logo sk-pl-2 pt-2 pb-3" [src]="clientIcon">
        </div>
      </div>
      <div class="sk-sidebar-logo-text">{{ clientNm }}</div>
    </div>
    <nav class="sk-sidebar-nav" *ngIf="menu">
      <ng-container *ngFor="let item of menu">
        <a class="sk-sidebar-nav-item"
          [class.sk-sidebar-nav-item-active]="item.selected"
          [class.sk-sidebar-nav-item--expanded]="item.expanded && item.children && !isMenuCollapse"
          [class.sk-sidebar-separator-after]="item.separator"
          [matTooltip]="(item.tooltip || item.title) | translate"
          matTooltipPosition="right"
          matTooltipClass="sk-sidebar-tooltip"
          (click)="toggleSubmenu(item)">
          <mat-icon *ngIf="isSvgIcon(item.icon)" [svgIcon]="item.icon" class="sk-sidebar-nav-icon" [ngClass]="item.selected ? 'sk-sidebar-icon-active' : 'sk-sidebar-icon-default'"></mat-icon>
          <span *ngIf="!isSvgIcon(item.icon) && isIconFont(item.icon)" class="sk-sidebar-nav-icon {{ item.icon }}" [ngClass]="item.selected ? 'sk-sidebar-icon-active' : 'sk-sidebar-icon-default'"></span>
          <mat-icon *ngIf="!isSvgIcon(item.icon) && !isIconFont(item.icon)" class="sk-sidebar-nav-icon" [ngClass]="item.selected ? 'sk-sidebar-icon-active' : 'sk-sidebar-icon-default'">{{ item.icon || 'circle' }}</mat-icon>
          <span class="sk-sidebar-nav-label" [ngClass]="item.selected ? 'sk-sidebar-icon-active' : 'sk-sidebar-icon-default'">{{ item.title | translate }}</span>
          <mat-icon *ngIf="item.children && !isMenuCollapse" class="sk-sidebar-nav-chevron">{{ item.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </a>
        <div *ngIf="item.children" class="sk-sidebar-submenu" [class.is-open]="item.expanded && !isMenuCollapse">
          <div class="sk-sidebar-submenu-inner">
            <a *ngFor="let child of item.children" class="sk-sidebar-submenu-item"
              [class.sk-sidebar-submenu-item-active]="child.selected"
              (click)="$event.stopPropagation(); selectMenuAndRoute(child.link)">
              <span class="sk-sidebar-submenu-label" [ngClass]="child.selected ? 'sk-sidebar-icon-active' : 'sk-sidebar-icon-default'">{{ child.title | translate }}</span>
            </a>
          </div>
        </div>
      </ng-container>
    </nav>
    <div class="sk-sidebar-collapse" (click)="collapseMenu()">
      <span [ngClass]="isMenuCollapse ? 'icon-Chevron-right-1' : 'icon-Chevron-left-1'" class="sk-sidebar-collapse-icon"></span>
    </div>
  </div>
</div>
